'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFormValues = require('./selectors/getFormValues');

var _getFormValues2 = _interopRequireDefault(_getFormValues);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _getFormValues2.default)(_plain2.default);


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/getFormValues.js
 ** module id = 981
 ** module chunks = 0
 **/